import { ClientDisplayableError } from '@standardnotes/responses';
import { FileDownloader } from '../UseCase/FileDownloader';
import { FileDecryptor } from '../UseCase/FileDecryptor';
export class DownloadAndDecryptFileOperation {
    constructor(file, crypto, api, valetToken) {
        this.file = file;
        this.crypto = crypto;
        this.api = api;
        this.downloader = new FileDownloader(this.file, this.api, valetToken);
    }
    createDecryptor() {
        return new FileDecryptor(this.file, this.crypto);
    }
    async run(onBytes) {
        const decryptor = this.createDecryptor();
        let decryptError;
        const onDownloadBytes = async (encryptedBytes, progress, abortDownload) => {
            const result = decryptor.decryptBytes(encryptedBytes);
            if (!result || result.decryptedBytes.length === 0) {
                decryptError = new ClientDisplayableError('Failed to decrypt chunk');
                abortDownload();
                return;
            }
            const decryptedBytes = result.decryptedBytes;
            await onBytes({ decrypted: { decryptedBytes }, encrypted: { encryptedBytes }, progress });
        };
        const downloadResult = await this.downloader.run(onDownloadBytes);
        return {
            success: downloadResult instanceof ClientDisplayableError ? false : true,
            error: downloadResult === 'aborted' ? undefined : downloadResult || decryptError,
            aborted: downloadResult === 'aborted',
        };
    }
    abort() {
        this.downloader.abort();
    }
}
